import script from "./AddProgramDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddProgramDialog.vue?vue&type=script&lang=ts&setup=true"

import "./AddProgramDialog.vue?vue&type=style&index=0&id=635a1bf6&lang=sass&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/gyEBPJq1/0/curvesdev/skolkovo-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-635a1bf6"]])

export default __exports__